import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";

export interface ReassignUserAssignmentsPayload {
  currentUserId: string;
  replacementUserId: string;
  roleId?: string;
}

export const reassignUserAssignmentsV2 = (
  data: ReassignUserAssignmentsPayload,
) => {
  return authenticatedFastApiAxiosInstance
    .patch<
      Record<string, unknown>
    >(`${baseFastApiMatterRoute}/users/assignments`, data)
    .then((res) => res.data);
};
